export enum CompetenceSSIAD {
	// 'Sans' = 'Sans',
	'INFIRMIER' = 'Infirmier.ère',
	'AIDESOIGNANT' = 'Aide soignant.te',
}

export enum CompetenceElementaireSSIAD {
	// 'Sans' = 'Sans',
	'INFIRMIER' = 'Infirmier.ère',
	'AIDESOIGNANT' = 'Aide soignant.te'
}

export enum CompetenceSAAD {
	// 'Sans' = 'Sans',
	'AIDEADOMICILE' = 'Aide à domicile'
}

export enum CompetenceSESSAD {
	// 'Sans' = 'Sans',
	'LPC' = 'LPC',
	'LSF' = 'LSF',
	'LPC_LSF' = 'LPC, LSF',
	'PRISE_DE_NOTES' = 'Prise de notes',
	'LPC_PRISE_DE_NOTES' = 'LPC, Prise de notes',
	'LSF_PRISE_DE_NOTES' = 'LSF, Prise de notes',
	'LPC_LSF_PRISE_DE_NOTES' = 'LPC, LSF, Prise de notes',
	'ORAL' = 'Oral',
	'LPC_ORAL' = 'LPC, Oral',
	'LSF_ORAL' = 'LSF, Oral',
	'LPC_LSF_ORAL' = 'LPC, LSF, Oral',
	'PRISE_DE_NOTES_ORAL' = 'Prise de notes, Oral',
	'LPC_PRISE_DE_NOTES_ORAL' = 'LPC, Prise de notes, Oral',
	'LSF_PRISE_DE_NOTES_ORAL' = 'LSF, Prise de notes, Oral',
	'LPC_LSF_PRISE_DE_NOTES_ORAL' = 'LPC, LSF, Prise de notes, Oral'
}

export enum CompetenceElementaireSESSAD {
	// 'Sans' = 'Sans',
	'LPC' = 'LPC',
	'LSF' = 'LSF',
	'PRISE_DE_NOTES' = 'Prise de notes',
	'ORAL' = 'Oral'
}

export function getCompetenceKeyByValue(value: string, competenceType: string) {
	let competenceToUse = null;
	if (competenceType === 'SSIAD') {
		competenceToUse = CompetenceSSIAD;
	} else if (competenceType === 'SAAD') {
		competenceToUse = CompetenceSAAD;
	} else if (competenceType === 'SESSAD') {
		competenceToUse = CompetenceSESSAD;
	}
	const indexOfCompetence = Object.values(competenceToUse).indexOf(value);
	const key = Object.keys(competenceToUse)[indexOfCompetence];
	return key;
}

export function getCompetenceElementaireFromCompetence(
	multipleCompetence: string,
	centerType: string
) {
	const listCompetenceElementaire = [];
	if (centerType === 'SESSAD') {
		if (multipleCompetence?.includes(CompetenceElementaireSESSAD.LPC)) {
			listCompetenceElementaire.push(CompetenceElementaireSESSAD.LPC);
		}
		if (multipleCompetence?.includes(CompetenceElementaireSESSAD.LSF)) {
			listCompetenceElementaire.push(CompetenceElementaireSESSAD.LSF);
		}
		if (
			multipleCompetence?.includes(
				CompetenceElementaireSESSAD.PRISE_DE_NOTES
			) ||
			multipleCompetence?.includes(
				getCompetenceKeyByValue(
					CompetenceElementaireSESSAD.PRISE_DE_NOTES,
					'SESSAD'
				)
			)
		) {
			listCompetenceElementaire.push(
				CompetenceElementaireSESSAD.PRISE_DE_NOTES
			);
		}
		if (
			multipleCompetence?.includes(CompetenceElementaireSESSAD.ORAL) ||
			multipleCompetence?.includes(
				getCompetenceKeyByValue(CompetenceElementaireSESSAD.ORAL, 'SESSAD')
			)
		) {
			listCompetenceElementaire.push(CompetenceElementaireSESSAD.ORAL);
		}
	} else if (centerType === 'SAAD') {
		if (
			multipleCompetence?.includes(CompetenceSAAD.AIDEADOMICILE) ||
			multipleCompetence?.includes(
				getCompetenceKeyByValue(CompetenceSAAD.AIDEADOMICILE, 'SAAD')
			)
		) {
			listCompetenceElementaire.push(CompetenceSAAD.AIDEADOMICILE);
		}
	} else if (centerType === 'SSIAD') {
		if (
			multipleCompetence?.includes(CompetenceSSIAD.AIDESOIGNANT) ||
			multipleCompetence?.includes(
				getCompetenceKeyByValue(CompetenceSSIAD.AIDESOIGNANT, 'SSIAD')
			)
		) {
			listCompetenceElementaire.push(CompetenceSSIAD.AIDESOIGNANT);
		}
		if (
			multipleCompetence?.includes(CompetenceSSIAD.INFIRMIER) ||
			multipleCompetence?.includes(
				getCompetenceKeyByValue(CompetenceSSIAD.INFIRMIER, 'SSIAD')
			)
		) {
			listCompetenceElementaire.push(CompetenceSSIAD.INFIRMIER);
		}
	}
	return listCompetenceElementaire;
}

export function getMultipleCompetenceFromListCompetenceElementaire(
	listCompetenceElementaire: string[],
	centerType: string
) {
	let keyToReturn = '';
	if (centerType === 'SESSAD') {
		if (listCompetenceElementaire.includes(CompetenceElementaireSESSAD.LPC)) {
			keyToReturn += 'LPC_';
		}
		if (listCompetenceElementaire.includes(CompetenceElementaireSESSAD.LSF)) {
			keyToReturn += 'LSF_';
		}
		if (
			listCompetenceElementaire.includes(
				CompetenceElementaireSESSAD.PRISE_DE_NOTES
			)
		) {
			keyToReturn += 'PRISE_DE_NOTES_';
		}
		if (listCompetenceElementaire.includes(CompetenceElementaireSESSAD.ORAL)) {
			keyToReturn += 'ORAL';
		}
		if (keyToReturn === '') {
			keyToReturn = 'Sans';
		}
		if (keyToReturn[keyToReturn.length - 1] === '_') {
			keyToReturn = keyToReturn.slice(0, -1);
		}
	} else if (centerType === 'SAAD') {
		if (listCompetenceElementaire.includes(CompetenceSAAD.AIDEADOMICILE)) {
			keyToReturn += 'AIDEADOMICILE';
		}
		if (keyToReturn === '') {
			keyToReturn = 'Sans';
		}
	} else if (centerType === 'SSIAD') {
		if (listCompetenceElementaire.includes(CompetenceSSIAD.INFIRMIER)) {
			keyToReturn += 'INFIRMIER_';
		}
		if (listCompetenceElementaire.includes(CompetenceSSIAD.AIDESOIGNANT)) {
			keyToReturn += 'AIDESOIGNANT';
		}
		if (keyToReturn === '') {
			keyToReturn = 'Sans';
		}
		if (keyToReturn[keyToReturn.length - 1] === '_') {
			keyToReturn = keyToReturn.slice(0, -1);
		}
	}
	
	return keyToReturn;
}
